var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-framework',{attrs:{"name":'安全管理',"hasRightBtn":true}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }